angular.module('impactx.controlstructure').controller('BasketControlStructureDialogCtrl', [
    '$mdDialog',
    'dataGen',
    'AppConfiguration',
    'BasketService',
    BasketControlStructureDialogController
]);

function BasketControlStructureDialogController($mdDialog, dataGen, AppConfiguration, BasketService) {
    var self = this;

    self.showDistributeAccountingButton = AppConfiguration.get('showDistributeAccountingButton');
    self.enableAutoAccountingDistribution = AppConfiguration.get('enableAutoAccountingDistribution');
    self.useAccountingHelper = AppConfiguration.get('useAccountingHelper');

    self.title = self.trns.controlTitle;

    self.helperDialogParams = BasketService.getControlHelperDialogParams(self.bks, self.bki)

    if (self.bks) {
        self.transferObject = self.bks;
        self.title = self.trns.controlsForBKS;
    }
    if (self.bki) {
        self.transferObject = self.bki;
        self.title = self.trns.controlsForBKI;
    }
    self.controls = angular.copy(self.controls);

    getControls(self.aatId).then(function (result) {
        self.aat = result.aat;
        self.controls = handlePreselection(result.control);
    });

    self.apply = function () {
        $mdDialog.hide(self);
    };

    self.abort = function () {
        $mdDialog.cancel();
    };

    self.changeAAT = function (selectedAATId) {
        self.requestInProgress = true;
        getControls(selectedAATId).then(function (result) {
            self.aat = result.aat;
            self.controls = result.control;
            self.requestInProgress = false;
        });
    };

    function getControls(aatId) {
        self.requestInProgress = true;
        var bksId = impactX.isDefined(self, 'bks.id') ? self.bks.id : 0;
        var bkiId = impactX.isDefined(self, 'bki.id') ? self.bki.id : 0;
        return dataGen.getData({}, {
            aatId: aatId,
            bksId: bksId,
            bkiId: bkiId
        }, '/basket/input/controlstructure').then(function (response) {
            self.requestInProgress = false;
            return impactX.isDefined(response, 'data');
        });
    }

    function handlePreselection(controls) {
        for (var key in controls) {
            if (controls.hasOwnProperty(key)) {
                var control = controls[key];
                if (self.preselectControl &&
                    impactX.isDefined(control, 'set.length') === 0 &&
                    impactX.isDefined(control, 'showMust') &&
                    impactX.isDefined(control, 'allowed.entries.length') === 1) {
                    var tmp = [];
                    tmp.push(control.allowed.entries[0]);
                    tmp[0].factor = 1;
                    control.set = tmp;
                }
            }
        }

        return controls;
    }
}